/**
 * Check if this is an "Everyone" recipe that doesn't have user data yet
 *
 * @type {Boolean}
 */
const isEveryoneRecipeWithoutUserData = () => {
	return UncannyAutomator.recipe.type == 'anonymous' && ! UncannyAutomator.recipe.requiresUserData;
}

export default isEveryoneRecipeWithoutUserData;